module.exports = __webpack_public_path__ + "media/loft.eac06997.jpg";